import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function Header({ title }) {
  const history = useHistory();

  return (
    <div className="d-flex align-items-center mb-1 flex-wrap">
      <div className="rounded d-flex align-items-center border p-2 pointer me-3" onClick={() => history.goBack()}>
        <i className="pi pi-angle-left"></i>
      </div>
      <h1 className="title gray-800 mb-0">{title}</h1>
    </div>
  );
}
